import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function ConsultingView() {
  useDocumentTitle('Consulting-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-15'}
        title={'Consultation'}
        link={'consultation'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">Consulting</h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">i</span>f you decide you
                  would like to have a consultation at home, following your
                  inquiry, then with your agreement, one of our management team
                  will visit you. The member of staff will spend time with you,
                  listening to your needs and requirements. This will allow for
                  the care plan to be compiled and processed which will tailor
                  the care we provide to your individual needs. After that, we
                  will then plan with you / your family how best we can support
                  you in your home or community. An assessment form will be
                  completed and agreed upon with you. Before the service finally
                  commences you will be introduced to the staff that is going to
                  work with you. We feel that is important as we want you to
                  feel comfortable
                </p>
                <p className="values_p">
                  Response to the inquiry by our management team (including a
                  comprehensive assessment of the client at no cost) to be
                  carried out by our team of care professionals.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default ConsultingView;
